export default (requestUrl, filters) => {
  for (const [key, value] of Object.entries(filters)) {
    if (value || value?.length || value === 0 || value === false) {
      if (typeof key === 'string' && key.toLowerCase().includes('_')) {
        const keyFromTo = key.split('_')

        if (keyFromTo.includes('to') || keyFromTo.includes('from')) {
          requestUrl = requestUrl + `&filters[${keyFromTo.slice(0, -1).join('_')}:${keyFromTo.at(-1)}]=${value}`
        }
        else requestUrl = requestUrl + `&filters[${key}]=${typeof value === 'string' ? value.toLowerCase() : value}`
      }
      else {
        requestUrl = requestUrl + `&filters[${key}]=${typeof value === 'string' ? value.toLowerCase() : value}`
      }
    }
  }
  
  return requestUrl
}
